<template>
  <article class="remark">
    <confirm
      v-model="show"
      title="您修改了“备注信息”，是否需要保存？"
      cancelText="取消"
      confirmText="保存"
      @on-cancel="onCancel"
      @on-confirm="onConfirm">
    </confirm>
    <group>
      <x-textarea
        v-model="remark"
        placeholder="请补充其他信息，如：改装说明、过户手续、注意事项等。"
        :show-counter="false"
        :height="300"
        :rows="10"
        :cols="40"
        style="line-height: 1.8;">
      </x-textarea>
    </group>
    <footer-btn title="保存备注信息" @submit="toSave()"></footer-btn>
  </article>
</template>

<script>
// 车辆信息(手续信息)
import {
  Group,
  Confirm,
  XTextarea
} from '@lx-frontend/cvux'
import FooterBtn from '../../components/FooterBtn'
import { remark } from './restConfig'
export default {
  components: {
    FooterBtn,
    Group,
    Confirm,
    XTextarea
  },
  props: {
    source: String,
    id: [String, Number],
    remarkInfo: String
  },
  data() {
    return {
      show: false, // 是否显示弹窗
      nextPage: '', // 下个页面
      remark: '', // 备注
      defaultNote: `全车有（   ）处喷漆，分别是：
经过钣金修复痕迹的部位分别是：
内饰描述：
发动机描述：
机械电器描述：
底盘传动描述：
悬挂描述：
需要进行喷漆/点漆的分别是：
需要进行机械电器整备的部件分别是：`
    }
  },
  created() {
    let note = this.$store.state.usedCar.note
    if (note) {
      this.remark = note
    } else {
      this.remark = this.defaultNote
    }
  },
  methods: {
    goToAnother (nextPage) {
      this.nextPage = nextPage
      if (this.remarkInfo !== this.remark) {
        this.show = true
      } else {
        this.$emit('on-after-save', nextPage)
      }
    },
    toSave(nextPage) {
      let url = remark.saveRemark[this.source](this.id)
      this.$rest.carInfo.create({
        note: this.remark
      }, url, { useJsonData: true }).then(res => {
        if (res.code === 0) {
          this.showToast('保存成功')
          this.$emit('update:remarkInfo', this.remark)
          if (nextPage) {
            this.$emit('on-after-save', nextPage)
          } else {
            this.$router.push(`/auction/carInfo/edit/${this.id}/${this.source}`)
          }
        } else {
          this.nextPage = ''
          this.showToast(res.message)
        }
      })
    },
    onConfirm() {
      this.show = false
      this.toSave(this.nextPage)
    },
    onCancel() {
      if (this.nextPage) {
        this.$emit('on-after-save', this.nextPage)
      } else {
        this.nextPage = ''
        this.show = false
      }
    }
  },
  watch: {
    remark(newVal) {
      this.$store.dispatch('UPDATE_CAR_REMARK_INFO', newVal)
    }
  }
}
</script>

<style rel="stylesheet/less" lang="less">
  @import "../../../stylesheets/modules/manage/input.less";
</style>
